// EventDetails.js

import React from 'react';
import { useParams } from 'react-router-dom';
import Footer from '../Footer/Footer';
import PageHeader from '../PageHeader/PageHeader';
import { events } from './EventList';
import './EventDetails.css';

const EventDetails = () => {
    const { id } = useParams();
    const event = events[id];

    return (
        <div>
            <div style={{ width: "100vw" }}>
                <PageHeader className="bgclass" heading={event.name} bgimg={event.img} />
            </div>
            <div className="event-details">
                <span className="event-details-date">Date: {event.date}</span>
                <img src={event.img} alt={event.name} className="event-details-image" />
                <p className="event-details-desc">{event.desc}</p>
            </div>
            <Footer />
        </div>
    );
};

export default EventDetails;
